import SimulatorImage from "../../resources/images/StaticPageImg/StickyPhoneSection/simulator-image.png";
import ImageOne from "../../resources/images/StaticPageImg/StickyPhoneSection/image-1.png";
import ImageTwo from "../../resources/images/StaticPageImg/StickyPhoneSection/image-2.png";

export const SimulatorMedia = {
  mediaType: "image",
  media: SimulatorImage,
};

export const GamePlayMedia = [
  {
    mediaType: "image",
    media: ImageOne,
  },
  {
    mediaType: "image",
    media: ImageTwo,
  },
  {
    mediaType: "image",
    media: ImageTwo,
  },
  {
    mediaType: "image",
    media: ImageOne,
  },
  {
    mediaType: "image",
    media: ImageOne,
  },
  {
    mediaType: "image",
    media: ImageTwo,
  },
  {
    mediaType: "image",
    media: ImageTwo,
  },
  {
    mediaType: "image",
    media: ImageOne,
  },
  {
    mediaType: "image",
    media: ImageOne,
  },
  {
    mediaType: "image",
    media: ImageTwo,
  },
  {
    mediaType: "image",
    media: ImageTwo,
  },
  {
    mediaType: "image",
    media: ImageOne,
  },
];

